module.exports = __webpack_public_path__ + "static/QuestionMark-3bd96bc4009ea57a5ab45bc8ad20b7af.gif";